/** 已前置校验（空企业初始态） */
export const ENT_STATUS_PRE_VALIDATED = 30;
/** 后置补全·待系统审核 */
export const ENT_STATUS_PRE_AUDITING = 31;
/** 后置补全·系统审核不通过 */
export const ENT_STATUS_PRE_AUDIT_FAIL = 32;
/** 后置补全·系统审核通过（首发活动审核通过后转 21） */
export const ENT_STATUS_PRE_AUDIT_SUCCESS = 33;
/** GetEntInitInfo.status：老入驻完成（库里 21 会映射成 6） */
export const ENT_INIT_AUDIT_SUCCESS = 6;

export const ENT_ENABLE_NORMAL = 1;
export const ENT_ENABLE_DISABLE = 2;

export const ENT_LAUNCH_HINT_DISABLED = '企业已被禁用，暂不可发起活动';
export const ENT_LAUNCH_HINT_UNCERTIFIED = '请先完成企业认证';
export const ENT_LAUNCH_HINT_FUND = '暂不可发起新的活动';
/** 公益金已过期（donation_date + 365 ≤ 今天）。TAPD 139053463 */
export const ENT_LAUNCH_HINT_FUND_EXPIRED = '公益金已过期，无法发起活动';
/** 公益金余额已用完（未过期但 unused_fund_amount === 0）。TAPD 139053463 */
export const ENT_LAUNCH_HINT_FUND_USED_UP = '无可用公益金';
export const ENT_CERT_INFO_PATH = '/entInfo';

export const ENT_HOME_PATH = '/donation';
export const ENT_SETTINGS_PATH = '/entInfo';

const ENT_HAS_ACTIVITY_KEY = 'ent_has_activity';
const ENT_HAS_DONATION_KEY = 'ent_has_donation';

/** 当前页内存：null 未查，true/false 已用本次 overview/list 结果。不写 session，登录/切企业后必重查。 */
let hasDonationFlag = null;
try {
  sessionStorage.removeItem(ENT_HAS_DONATION_KEY);
} catch (error) {
  console.log('error', error);
}

/** 老 B2B 活动入口：活动管理、数据导出任务列表 */
export const LEGACY_ACTIVITY_ENTRY_PATHS = ['/actList', '/exportList'];

/** 登录后侧栏可进的平台页，守卫不再踢去注册/活动入驻 */
export const ENT_PLATFORM_MENU_PATHS = ['/donation', '/report', '/fundActivity', '/actList', '/entInfo', '/member', '/exportList'];

export function isEntPlatformMenuPath(path) {
  return ENT_PLATFORM_MENU_PATHS.some(item => path === item || path.startsWith(`${item}/`));
}

export function isLegacyActivityEntryPath(path) {
  return LEGACY_ACTIVITY_ENTRY_PATHS.some(item => path === item || path.startsWith(`${item}/`));
}

export function isDonationEntryPath(path) {
  return path === '/donation'
    || path.startsWith('/donation/')
    || path === '/fundActivity'
    || path.startsWith('/fundActivity/');
}

/** GetEntInitInfo.has_activity：有类型 1/2/4/5 的存量活动才为 true */
export function parseHasActivity(res) {
  const value = res && (res.has_activity !== undefined ? res.has_activity : res.hasActivity);
  return value === true || value === 1 || value === '1';
}

export function persistEntInitSession(res) {
  try {
    sessionStorage.setItem('ent_init_info', JSON.stringify(res && res.org_info));
    sessionStorage.setItem(ENT_HAS_ACTIVITY_KEY, parseHasActivity(res) ? '1' : '0');
  } catch (error) {
    console.log('error', error);
  }
}

export function readHasActivity() {
  return sessionStorage.getItem(ENT_HAS_ACTIVITY_KEY) === '1';
}

function unwrapOverview(overview) {
  if (!overview || typeof overview !== 'object') return overview;
  const nested = overview.data;
  if (!nested || typeof nested !== 'object' || Array.isArray(nested)) return overview;
  const keys = [
    'project_count', 'projectCount',
    'total_amount', 'totalAmount',
    'awaiting_amount', 'awaitingAmount',
    'executing_count', 'executingCount',
    'pending_invoice_count', 'pendingInvoiceCount',
    'unused_fund_amount', 'unusedFundAmount',
  ];
  const hasTop = keys.some((key) => overview[key] !== undefined && overview[key] !== null && overview[key] !== '');
  if (hasTop) return { ...overview, ...nested };
  return nested;
}

export function parseHasDonation(overview) {
  const src = unwrapOverview(overview);
  if (!src) return false;
  return Number(src.total || 0) > 0
    || Number(src.project_count || src.projectCount || 0) > 0
    || Number(src.total_amount || src.totalAmount || 0) > 0
    || Number(src.awaiting_amount || src.awaitingAmount || 0) > 0
    || Number(src.executing_count || src.executingCount || 0) > 0
    || Number(src.pending_invoice_count || src.pendingInvoiceCount || 0) > 0
    || Number(src.unused_fund_amount || src.unusedFundAmount || 0) > 0;
}

export function persistHasDonation(overview) {
  if (!overview) return;
  hasDonationFlag = parseHasDonation(overview);
  try {
    sessionStorage.removeItem(ENT_HAS_DONATION_KEY);
  } catch (error) {
    console.log('error', error);
  }
}

export function clearHasDonationFlag() {
  hasDonationFlag = null;
  try {
    sessionStorage.removeItem(ENT_HAS_DONATION_KEY);
  } catch (error) {
    console.log('error', error);
  }
}

/** 未查过概览时先展示捐赠入口，确认无捐赠后再藏 */
export function readHasDonation() {
  if (hasDonationFlag === null) return true;
  return hasDonationFlag === true;
}

export function resolveHomePathByFlags(hasDonation, hasActivity) {
  if (hasDonation) return ENT_HOME_PATH;
  if (hasActivity) return '/actList';
  return ENT_SETTINGS_PATH;
}

export function resolveHomePath() {
  return resolveHomePathByFlags(readHasDonation(), readHasActivity());
}

/**
 * 老入驻向导流程中的 GetEntInitInfo.status：
 * 0 未入驻、1 已提交企业、2 已提交活动、3/4/5 冻结流程、11 企业驳回、12 活动驳回、13 冻结失败。
 * 登录阶段命中时停在无捐赠引导页，不自动跳步骤页；用户点入驻入口后再由路由守卫分流。
 * 不含 6（老入驻已完成）与 30–33（新链路，见 isEntHomeReadyStatus）。
 */
const ENT_ONBOARDING_STATUS_LIST = [0, 1, 2, 3, 4, 5, 11, 12, 13];

export function isEntOnboardingStatus(status) {
  return ENT_ONBOARDING_STATUS_LIST.includes(Number(status));
}

/** 前置校验企业：30–33 直接进首页，不走老入驻/活动链路 */
export function isEntHomeReadyStatus(status) {
  const n = Number(status);
  return n >= ENT_STATUS_PRE_VALIDATED && n <= ENT_STATUS_PRE_AUDIT_SUCCESS;
}

/** 新链路认证通过(33)或老入驻完成(6) */
export function isEntCertPassed(initStatus) {
  const n = Number(initStatus);
  return n === ENT_STATUS_PRE_AUDIT_SUCCESS || n === ENT_INIT_AUDIT_SUCCESS;
}

/**
 * 发起活动按钮拦截原因。优先禁用，再看认证。
 * GetEntInitInfo：enabled=3 时不回 org_info 且 status=0，按未认证处理。
 */
export function getEntLaunchBlockReason(initInfo = {}) {
  const orgInfo = initInfo.org_info || {};
  if (Number(orgInfo.enabled) === ENT_ENABLE_DISABLE) {
    return ENT_LAUNCH_HINT_DISABLED;
  }
  if (!isEntCertPassed(initInfo.status)) {
    return ENT_LAUNCH_HINT_UNCERTIFIED;
  }
  return '';
}
